import { useFormikContext } from "formik";

import AuthCode from "react-auth-code-input";
import Row from "./row";
import Col from "./col";
import { useTranslation } from "react-i18next";

export default function Code({ name, className, disabled }) {
  const formik = useFormikContext();
  const { t } = useTranslation();

  const handleChange = (e) => {
    formik?.setFieldValue(name, e);
  };

  return (
    <Col className="w-100">
      <Row className={`element _code ${className ? className : ""}`}>
        <article className="code-row w-100">
          <AuthCode
            length={6}
            autoFocus={false}
            isPassword={true}
            disabled={disabled}
            allowedCharacters="numeric"
            onChange={(e) => handleChange(e)}
          />
        </article>
      </Row>
      <Row>
        {(formik?.touched?.[name] || formik?.submitCount > 0) && formik?.errors?.[name] ? (
          <div className="element _errors">{t(formik.errors[name])}</div>
        ) : null}
      </Row>
    </Col>
  );
}
